import { h } from "preact";
import { useEffect } from "preact/hooks";
import { when } from "mobx";
import { observer } from "mobx-react";
import { t, translate } from "../../I18n";
import CartProducts from "./CartProducts";
import CartPromotions from "./CartPromotions";
import FulfillmentMethodForm from "../../components/FulfillmentMethodForm";
import FulfillmentTimeForm from "../../components/FulfillmentTimeForm";
import CartSummaryRows from "./CartSummaryRows";
import Alert from "../../components/Alert";
import AvailabilityDebugInfo from "../../components/AvailabilityDebugInfo";
import CrossSellingList from "../../components/CrossSellingList";
import { Tracking } from "restaumatic-client";
function CartBody(props) {
    var _a;
    const { state } = props;
    const { cart } = state;
    const { fulfillmentFormController } = cart;
    const crossSellingItems = cart.crossSellingCreator.items.raw;
    const isImageVisible = Boolean(Number(window.Skubacz.configuration.theme_settings.cart_dish_images));
    const imageType = window.Skubacz.configuration.theme_settings.dish_image_style ===
        "rounded-circle"
        ? "circle"
        : "square";
    const isFulfillmentFormVisible = fulfillmentFormController.type !== "QrWaiter";
    const isFulfillmentTimeFormVisible = cart.orderDetails.fulfillmentTime.type !== "QrWaiter";
    useEffect(() => {
        return when(() => cart.error.type == "NotOverlappingDishes", () => {
            Tracking.trackEvent({
                tag: "NotOverlappingDishes",
                contents: {
                    action: "not_overlapping_delivery_times_message",
                    category: "cart",
                    label: cart.restaurantName,
                },
            });
        });
    }, []);
    return (h("div", { class: "modal-body js-popover-container" },
        h("div", { class: "u-childs-separator" },
            h(CartProducts, { mode: "editable", items: cart.orderLines, isImageVisible: isImageVisible, imageType: imageType }),
            h(CartPromotions, { fodState: cart.fodState, fodController: cart.fodFormController, promotions: cart.promotions, couponState: cart.couponState, cartMeetsCouponPromotionConditions: cart.cartMeetsCouponPromotionConditions }),
            isFulfillmentFormVisible && (h("form", { class: "delivery is-editing" },
                h("h5", null, translate(t.orders.form.fulfillment_options)),
                isFulfillmentTimeFormVisible && (h(FulfillmentTimeForm, { fulfillmentTime: cart.orderDetails.fulfillmentTime, controller: fulfillmentFormController.fulfillmentTimeController, openingHour: cart.restaurantOpeningHour })),
                h(FulfillmentMethodForm, { orderDetails: cart.orderDetails, options: cart.fulfillmentMethodsOptions, controller: fulfillmentFormController.fulfillmentMethodController, withApartmentInfo: false, withNoContactDelivery: false, isStored: cart.orderDetails.isStoredFulfillmentMethodCart })))),
        h(Alert, { type: cart.error.level, message: (_a = cart.error) === null || _a === void 0 ? void 0 : _a.message, fieldId: "cart.error" }),
        h(AvailabilityDebugInfo, { name: "Cart", fieldId: "cart", availability: cart.availability }),
        h(CartSummaryRows, { purchaseOrder: cart.purchaseOrder }),
        crossSellingItems.length > 0 && (h(CrossSellingList, { items: crossSellingItems }))));
}
export default observer(CartBody);
